import { render, staticRenderFns } from "./CreateOpenMenu.vue?vue&type=template&id=f0730508&"
import script from "./CreateOpenMenu.vue?vue&type=script&lang=js&"
export * from "./CreateOpenMenu.vue?vue&type=script&lang=js&"
import style0 from "./CreateOpenMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports